import { useSyncExternalStore } from 'react';

/**
 * Whether there is room for the details column beside the inbox and the thread.
 * The rail, the inbox and the panel at its default width take ~750px (68 + 340 + 340),
 * so below this the thread would be the narrowest pane on screen.
 *
 * A different question from `useIsMobile`, which asks whether a SECOND column
 * fits. Only the details panel's DEFAULT reads this: opening it by hand stays
 * offered at every width, so the employer can still choose the squeeze.
 */
const mql =
  typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(min-width: 1100px)')
    : null;

function subscribe(onChange: () => void): () => void {
  mql?.addEventListener('change', onChange);
  return () => mql?.removeEventListener('change', onChange);
}

export function useFitsThreeColumns(): boolean {
  return useSyncExternalStore(subscribe, () => mql?.matches ?? false);
}
